import { type CSSObject } from '@emotion/react';
import { useTheme, type ThemeNames } from '../theme';

type Return = Record<'link' | 'button', CSSObject>;

export const useLinkStyles = ({
  themeName,
  color,
}: {
  themeName?: ThemeNames;
  color?: string;
}): Return => {
  const theme = useTheme(themeName);
  return {
    link: {
      color: color ?? theme.text.link.default,
      textDecoration: 'underline',

      '&:hover, &:focus': {
        color: color ?? theme.text.link.hover,
      },
    },
    button: {
      border: 'none',
      background: 'none',
      padding: 0,
    },
  };
};
